import { StyledAllProgramsTeaser as AllProgramsTeaser, allProgramsTeaserFragment } from './AllProgramsTeaser.jsx';

export const allProgramsTeaserAdapterFragment = allProgramsTeaserFragment;

export const AllProgramsTeaserInterfaceAdapter = ({ className, contents = [] }) => {
  const [firstContent] = contents;

  return <AllProgramsTeaser className={className} programsOverview={firstContent}/>;
};
